const Model = require("../types/Model.js");
const debounce = require("debounce");

module.exports = Model({
	name: "customoptions",
	init: init,
	uninit,
	listeners,
	triggers,
	recalculate,
	handleSearch,
	search,
	_tracker: null,
});

function init() {
	this._externals = {};
	this._tracker = this.dispatcher.createTracker();
	this._viewing = null;
	this._page = 0;
	this.push([]);
}

function uninit() {
	this._tracker.off();
	this._tracker = null;
	this._page = 0;
	this.push([]);
}


function listeners() {
	return {
		"groupformlist:updated": Model.makeRecalculator("groupForms"),
		"ownformlist:updated": Model.makeRecalculator("ownGroupForms"),
		"managedgroupformlist:updated": Model.makeRecalculator("managedGroupForms"),
		"workflowinstances:updated": Model.makeRecalculator("workflows"),
		"manageddefinitionworkflow:updated": Model.makeRecalculator("managedWorkflows"),

		"ownformsubmissions:viewing": handle_form_viewing,
		"managedgroupformsubmissions:viewing": handle_form_viewing,
		"groupformsubmissions:viewing": handle_form_viewing,
		"activeworkflowaction:updated": handle_workflow_viewing,
	};
}

function triggers(){
	return {
		add: add,
		edit: edit,
		start: start,
		search: debounce(search, 100),
		more: more,
		viewingForm: viewingForm,
	};
}

function recalculate(){
	const groupForms = this._groupForms || {};
	const ownGroupForms = this._ownGroupForms || {};
	const managedGroupForms = this._managedGroupForms || {};
	const workflows = this._workflows || {};
	const managedWorkflows = this._managedWorkflows || [];

	var externals = Object.keys(groupForms).reduce((result, key) => {
		const groupForm = groupForms[key];
		result[groupForm._id] = groupForm.externals || {};
		return result;
	}, {});

	externals = Object.keys(ownGroupForms).reduce((result, key) => {
		const groupForm = ownGroupForms[key];
		result[groupForm._id] = groupForm.externals || {};
		return result;
	}, externals);

	externals = Object.keys(managedGroupForms).reduce((result, key) => {
		const groupForm = managedGroupForms[key];
		result[groupForm._id] = groupForm.externals || {};
		return result;
	}, externals);

	externals = Object.keys(workflows).reduce((result, key) => {
		const workflow = workflows[key];
		result[workflow.workflowId] = workflow.externals || {};
		return result;
	}, externals);

	externals = managedWorkflows.reduce((result, workflow) => {
		result[workflow.workflow] = workflow.externals || {};
		return result;
	}, externals);

	this._externals = externals;
}

function handle_form_viewing(data){
	if(!data) return;
	const viewing = data.form;
	if(viewing)
		this._viewing = this._externals[viewing] || {};
}

function handle_workflow_viewing(data){
	if(!data) return;
	const ongoingWorkflow = data.ongoingWorkflow || {};
	const workflowId = ongoingWorkflow.workflowId;

	if(!workflowId) return;

	this._viewing = this._externals[workflowId] || {};
}

function start(data){
	return this.search(data).then(() => {
		if (this.config.orgGroup) {
			const tracker = this._tracker;
			tracker.off();
			tracker.on(`mqtt:orggroup/${this.config.orgGroup}/option/updated`, handle_updated.bind(this));
			tracker.on(`mqtt:orggroup/${this.config.orgGroup}/option/removed`, handle_removed.bind(this));
			tracker.on(`mqtt:orggroup/${this.config.orgGroup}/option/added`, handle_added.bind(this));
		}

		this.dispatch("loaded");
	});
}

function handle_updated(data) {
	const currentList = this.data || [];
	const newList = [];
	currentList.map(item => {
		if(item._id === data._id) {
			newList.push(data)
		} else {
			newList.push(item)
		}
	})
	setList.call(this, newList);
	this.dispatch("updated", newList);
}

function handle_removed(data) {
	const currentList = this.data || [];
	const newList = currentList.filter(item => item._id !== data._id)
	setList.call(this, newList);
	this.dispatch("updated", newList);
}

function handle_added(data) {
	const currentList = this.data || [];
	currentList.push(data)
	setList.call(this, currentList);
	this.dispatch("updated", currentList);
}

async function add(data){
	const viewing = this._viewing;
	if(!viewing) return Promise.resolve();
	const externalKey = data.external;
	const schemaId = viewing[externalKey];
	if(!schemaId) return Promise.resolve();
	const optionData = data.newData;
	if(!optionData) return Promise.resolve();
	return this.api.org.options.addOption(schemaId, optionData)
		.then(async () => {
			const newList = await this.api.options.search(schemaId, [], null, 0);
			this.dispatch("updated", newList);
		})
		.catch(handle_error.bind(this));
}


function search(data){
	const viewing = this._viewing;
	if(!viewing) return Promise.resolve();

	const fields = data.fields;
	const externalKey = data.external;
	let query = data.query;

	const schemaId = viewing[externalKey];

	if(!schemaId) return Promise.resolve();

	if(!query){
		query = null;
		this._page = 0;
	}

	this._schemaId = schemaId;
	this._query = query;
	this._fields = fields;

	return this.api.options.search(schemaId, fields, query, this._page)
		.then(setList.bind(this))
		.then(atEnd.bind(this))
		.catch(handle_error.bind(this));
}

function setList(options){
	this.push(options);
	return options;
}

function addToList(options){
	const current = this.data;
	const newList = current.concat(options);
	this.push(newList);
	return options;
}

function more(data){
	this._page++;
	this.handleSearch(data)
		.then(addToList.bind(this))
		.then(atEnd.bind(this))
		.catch(handle_error.bind(this));
}

function atEnd(options){
	if(options.length < 32)
		this.dispatch("should:load", false);
	else
		this.dispatch("should:load", true);
}

function handleSearch(){
	return this.api.options.search(this._schemaId, this._fields, this._query, this._page);
}

function handle_error(error){
	console.error(error);
}

function viewingForm(formId){
	this._viewing = this._externals[formId] || {};
}

function edit(data){
	const newData = data.newData;
	if(!newData) return Promise.resolve();
	const optionId = newData?._id;
	if(!optionId) return Promise.resolve();
	const updatedData = Object.keys(newData).filter(k => k !== "_id").reduce((acc, key) => ((acc[key] = newData[key]), acc),{});

	return this.api.org.options.updateOption(optionId, updatedData)
		.then(async () => {
			const newList = await this.api.options.search(this._schemaId, [], null, 0);
			this.dispatch("updated", newList);
		})
		.catch(handle_error.bind(this));
}